/* eslint-disable @next/next/no-img-element */
import React, { useEffect } from "react";

import classNames from "classnames/bind";
import { CMSImage } from "common/blocks/Image/cms-image";
import { ResolvedImage } from "resolvers/data/imageResolver";
import { VehicleService } from "services/vehicle/vehicle";

import styles from "./MobileScrollGallery.module.scss";

const cx = classNames.bind(styles);

export type MobileScrollGalleryProps = {
    images?: VehicleService.MarketingImage[];
    cmsMedia?: ResolvedImage[];
    className?: string;
    initialSlide?: number;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const MobileScrollGallery = ({
    images,
    cmsMedia,
    className,
    initialSlide,
    ...rest
}: MobileScrollGalleryProps) => {
    useEffect(() => {
        const selectedImage = document.querySelectorAll(`[data-key='${initialSlide}']`)[0];
        selectedImage.scrollIntoView();
    }, [initialSlide]);

    return (
        <div {...rest} className={cx("scrollContainer", className)}>
            {cmsMedia?.length
                ? cmsMedia?.map((cmsImage, index) => (
                      <React.Fragment key={cmsImage.codename}>
                          <CMSImage
                              src={cmsImage.src}
                              alt={cmsImage.alt}
                              key={index}
                              data-key={index}
                              width={cmsImage.width}
                              height={cmsImage.height}
                          />
                      </React.Fragment>
                  ))
                : images?.map((image, index) => (
                      <img
                          key={index}
                          data-key={index}
                          className={cx("imageMedia")}
                          loading="lazy"
                          src={image.Uri}
                          alt={image.Description}
                      />
                  ))}
        </div>
    );
};

export default MobileScrollGallery;
